import { useEffect } from "react";
import { useForm } from "react-hook-form";

import { InputDateControllerVertical, InputTextVertical } from "@components";

import { RequisitionDetailsResponseType } from "@type/inventory/requisition-details";

type Props = {
  data: RequisitionDetailsResponseType | null;
};

function DetailsForm({ data }: Props) {
  const { setValue, register, control } = useForm();

  const filedNames = {
    reqFor: "reqFor",
    reqDate: "reqDate",
    office: "office",
    building: "building",
    floor: "floor",
    room: "room",
    desk: "desk",
    reqNo: "reqNo",
  };

  useEffect(() => {
    const { officeInformation } = data || {};
    Object.entries(filedNames).forEach(([fieldName, dataKey]) => {
      setValue(fieldName, officeInformation?.[dataKey] || "");
    });
  }, [data]);

  return (
    <div className="row p-0 mx-0 mb-20">
      <InputTextVertical
        label="INVENTORY_REQUISITION.REQUISITION_DETAILS.FORM.FIELD_1"
        name="reqFor"
        register={{
          ...register("reqFor"),
        }}
        setValue={setValue}
        inputSize="sm"
        disabled
        cols={4}
      />
      <InputDateControllerVertical
        control={control}
        label="INVENTORY_REQUISITION.REQUISITION_DETAILS.FORM.FIELD_2"
        name="reqDate"
        inputSize="sm"
        disabled
        cols={4}
      />
      <InputTextVertical
        label="INVENTORY_REQUISITION.REQUISITION_DETAILS.FORM.FIELD_3"
        name="office"
        register={{
          ...register("office"),
        }}
        setValue={setValue}
        inputSize="sm"
        disabled
        cols={4}
      />
      <InputTextVertical
        label="INVENTORY_REQUISITION.REQUISITION_DETAILS.FORM.FIELD_4"
        name="building"
        register={{
          ...register("building"),
        }}
        setValue={setValue}
        inputSize="sm"
        disabled
        cols={4}
      />
      <InputTextVertical
        label="INVENTORY_REQUISITION.REQUISITION_DETAILS.FORM.FIELD_5"
        name="floor"
        register={{
          ...register("floor"),
        }}
        setValue={setValue}
        inputSize="sm"
        disabled
        cols={4}
      />
      <InputTextVertical
        label="INVENTORY_REQUISITION.REQUISITION_DETAILS.FORM.FIELD_6"
        name="room"
        register={{
          ...register("room"),
        }}
        setValue={setValue}
        inputSize="sm"
        disabled
        cols={4}
      />
      <InputTextVertical
        label="INVENTORY_REQUISITION.REQUISITION_DETAILS.FORM.FIELD_7"
        name="desk"
        register={{
          ...register("desk"),
        }}
        setValue={setValue}
        inputSize="sm"
        disabled
        cols={4}
      />
      <InputTextVertical
        label="INVENTORY_REQUISITION.REQUISITION_DETAILS.FORM.FIELD_8"
        name="reqNo"
        register={{
          ...register("reqNo"),
        }}
        setValue={setValue}
        inputSize="sm"
        disabled
        cols={4}
      />
    </div>
  );
}

export default DetailsForm;
